const groupCreateButtonModalEquipService = {
  text: 'Criar Seção +'
};

export default groupCreateButtonModalEquipService;
